"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("./vue"));
exports.js2jsxByVue = vue_1.default;
var react_1 = __importDefault(require("./react"));
exports.js2jsxByReact = react_1.default;
exports.default = {
    js2jsxByVue: vue_1.default,
    js2jsxByReact: react_1.default
};
//# sourceMappingURL=index.js.map